export { default as Icon } from './icon'



// WEBPACK FOOTER //
// ./src/components/atoms/icon/index.ts